import React from "react";

interface HowItWorksModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const HowItWorksModal: React.FC<HowItWorksModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded-mediumRound shadow-lg max-w-4xl w-full mx-4 p-8 relative max-h-[90vh] overflow-hidden">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 z-10"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Content with scroll */}
        <div className="max-h-[80vh] overflow-y-auto pr-4">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-primary mb-3">How It Works</h1>
          </div>
          <div className="space-y-6 text-base text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-primary mb-2">1. Browse & Explore</h2>
              <ul className="ml-6 mb-2 list-disc space-y-1">
                <li>Clients land on droneden.ro and can use the search functions to find the best pilots for their aerial needs.</li>
                <li>Filter by location, aerial-service type (real-estate, inspections, events, etc.), or search by keywords.</li>
                <li>Click a Pilot’s card to view information, portfolio, and pricing.</li>
              </ul>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-primary mb-2">2. Get Jobs as a Pilot</h2>
              <ul className="ml-6 mb-2 list-disc space-y-1">
                <li>Sign up with a PFA/SRL email, upload drone licence, insurance, and ID for KYC.</li>
                <li>Build your Pilot Profile: add services, packages, hourly or per-mission rates, travel radius, and sample footage.</li>
              </ul>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-primary mb-2">3. Chat & Finalise Details</h2>
              <ul className="ml-6 mb-2 list-disc space-y-1">
                <li>Use the communication means provided by DroneDen to swap flight plans, permit needs, and weather updates.</li>
                <li>All written confirmations stay on the platform—no off-site emailing required.</li>
              </ul>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-primary mb-2">4. Fly & Deliver</h2>
              <ul className="ml-6 mb-2 list-disc space-y-1">
                <li>Complete the Mission, upload or hand over the agreed footage/data.</li>
                <li>Client accepts deliverables and funds are released (or auto-release after 48h of silence).</li>
              </ul>
            </section>
            <section>
              <h2 className="text-lg font-semibold text-primary mb-2">5. Payments & Fees</h2>
              <ul className="ml-6 mb-2 list-disc space-y-1">
                <li>From the total sum of money a client pays for an aerial imagery project:</li>
                <li><strong>80%</strong> goes to the Pilot.</li>
                <li><strong>20%</strong> is DroneDen’s all-inclusive fee.</li>
                <li>Invoices are auto-generated for both parties and downloadable from the dashboard or sent directly to the involved parties by the DroneDen team.</li>
              </ul>
            </section>
          </div>
          <div className="mt-7 p-4 bg-gray-100 rounded-lg text-center font-semibold text-primary">
            That’s it—find, fly, get paid.
            <br />
            No hidden costs, no cash hassles, just safe escrow and a transparent 20% platform fee.
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksModal;